import {Injectable} from '@angular/core';
import {ResponseData} from '../../ResponseData.interface';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {v4 as uuid} from 'uuid';
import {environment} from '../../../../environments/environment.prod';

const PRODUCT_URL = environment.API_URL + 'product';

@Injectable()
export class ProductService {
  id: string;

  constructor(private http: HttpClient) {
  }

  getProducts(page_size?: number, page_no?: number) {
    const request: any = {page_size, page_no};
    return this.http.get<ResponseData>(PRODUCT_URL, {params: request});
  }

  getSearchedProduct(parameters): Observable<ResponseData> {
    return this.http.get<ResponseData>(PRODUCT_URL + '/search-side-bar', {params: parameters});
  }

  getSearchResults(parameters): Observable<ResponseData> {
    return this.http.get<ResponseData>(PRODUCT_URL + '/search', {params: parameters});
  }

}
